import { FieldViewModel, DatalayersMap } from "../../../omnia"
import { EditFeature } from "../edit-feature"
import { EditLayer } from "../edit-layer"

import IMapTopologyService = omnia.map.IMapTopologyService
import DrawMarginInteraction = omnia.map.DrawMarginInteraction
import { ol_source } from "@omnia/exports/openlayers"

export class DrawBufferContext extends omnia.map.DrawMarginContext<DatalayersMap> {

    private _zone: EditFeature


    constructor(map: DatalayersMap, topo: IMapTopologyService, private targetLayer: EditLayer) {
        super(map, topo)
    }

    setWidth(width: number) {
        if (this._zone) {
            this._zone.buffer = width
        }
        super.setWidth(width)
    }

    startDrawing(zone: EditFeature, watcher: (() => void)) {

        this.setupInteraction()

        if (zone.bufferLine) {
            this.interaction.setInitialState(zone.bufferLine)
        }

        this._zone = zone

        zone.setInitialState()

        this._width = zone.buffer
        this._fullBoundary = !!(zone.bufferLine && this.interaction.fullBoundary)

        this.interaction.geometryFunction = line => this.bufferMargin(line, false)
        this.setupChangeWatcher(() => this.handleChange(watcher))

        this.updateStyle()

        this.interaction.setActive(true)

    }

    updateStyle() {

        if (this._zone) {
            //this.interaction.setMarginStyle({ color: this._zone.fillColor, text: this._zone.label })
            this.interaction.setMarginStyle({ color: this._zone.fillColor, text: null })
        }

    }

    commitEdit() {

        if (!this.isActive()) return true
        if (!this.canCommit()) return false

        this.updateTargetZone(true)

        this.cancelEdit()

        return true

    }

    cancelEdit() {
        this._zone = null
        super.cancelEdit()
    }

    private handleChange(watcher: (() => void)) {

        this._currentDimensions = undefined

        this.updateTargetZone(false)

        if (watcher && this.interaction.targetFeature) {
            watcher()
        }

    }

    private updateTargetZone(commit: boolean) {

        const { selection, targetFeature } = this.interaction

        if (selection && targetFeature && this._zone) {

            const field = <FieldViewModel>targetFeature.get("data")

            const geom = this.bufferMargin(selection, commit)

            let feature = this._zone.feature

            if (!feature) {
                feature = this.targetLayer.createNewFeature(geom, this._zone)
                this._zone.setFeature(feature)
                this._zone.commitState()
            }

            this._zone.setBufferInfo(field.fieldId, selection, geom)

            return true

        }

    }

    private setupInteraction() {

        if (!this.interaction) {

            const fieldLayer = this.map.fieldsLayer
            const fieldId = this.targetLayer.fieldId

            const fieldFeatures = fieldId
                ? fieldLayer.findFeatures(f => f.get("data").fieldId == fieldId)
                : null

            const source = (fieldFeatures && fieldFeatures.length)
                ? new ol_source.Vector({ features: fieldFeatures })
                : fieldLayer.mapLayer.getSource()

            this.interaction = new DrawMarginInteraction(source)

            this.olmap.addInteraction(this.interaction)

        }

    }

}
